import React from "react";
import { V2NftMetadata } from "types";

export type V2ContextValue = {
  tokenId?: number;
  metadata?: V2NftMetadata;
  isLoading: boolean;
  fetchMetadata: () => void;
};

const V2Context = React.createContext<V2ContextValue>({
  isLoading: false,
  fetchMetadata: () => {},
});

export default V2Context;
